/**
 * Navigation bar component
 */
import { useAuth } from '../../auth'
import { Button } from '../common'
import { useCommandPalette } from '../CommandPalette'
import { PortfolioSelector } from './PortfolioSelector'

export function Navbar() {
  const { user, signOut } = useAuth()
  const { open: openCommandPalette } = useCommandPalette()

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-gray-200">
      <div className="max-w-full px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          {/* Logo + Portfolio Selector */}
          <div className="flex items-center gap-4">
            <div className="flex-shrink-0 flex items-center">
              <svg
                className="h-8 w-8 text-primary-600"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M3 3v18h18M19 9l-5 5-4-4-3 3"
                />
              </svg>
              <span className="ml-2 text-xl font-semibold text-gray-900 hidden sm:inline">
                Portfolio Tracker
              </span>
            </div>
            <div className="h-6 w-px bg-gray-200 hidden sm:block" />
            <PortfolioSelector />
          </div>

          {/* Center - Search trigger */}
          <div className="flex-1 flex items-center justify-center px-4 max-w-lg">
            <button
              onClick={openCommandPalette}
              className="w-full flex items-center gap-2 px-3 py-1.5 text-sm text-gray-500 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors"
            >
              <SearchIcon className="h-4 w-4" />
              <span className="flex-1 text-left">Search commands...</span>
              <kbd className="hidden sm:inline-flex items-center gap-1 px-1.5 py-0.5 text-xs bg-white border border-gray-300 rounded">
                <span className="text-xs">&#8984;</span>K
              </kbd>
            </button>
          </div>

          {/* User menu */}
          <div className="flex items-center space-x-4">
            {user && (
              <>
                <span className="text-sm text-gray-500">
                  {user.signInDetails?.loginId || user.username}
                </span>
                <Button variant="secondary" size="sm" onClick={signOut}>
                  Sign Out
                </Button>
              </>
            )}
          </div>
        </div>
      </div>
    </nav>
  )
}

function SearchIcon({ className }: { className?: string }) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
    </svg>
  )
}
